interface LocationLike {
  hostname: string;
  origin: string;
}

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

export const resolveApiBaseUrl = (
  configuredUrl: string | undefined = process.env.REACT_APP_BASE_URL,
  locationLike: LocationLike | undefined = typeof window === "undefined" ? undefined : window.location,
): string => {
  if (locationLike?.hostname.endsWith(".localhost")) {
    return `${trimTrailingSlash(locationLike.origin)}/api/v1`;
  }

  const configured = configuredUrl?.trim();
  return trimTrailingSlash(configured || "/api/v1");
};

export const API_BASE_URL = resolveApiBaseUrl();
